import React from 'react';
import Loader from '../Loader';
import { StyledEmptyPageLoaderContainer, StyledEmptyPageLoaderContent } from './styles';

const EmptyPageLoader: React.FC = () => {
    return (
        <StyledEmptyPageLoaderContainer data-testid="empty-page-loader">
            <StyledEmptyPageLoaderContent>
                <Loader />
            </StyledEmptyPageLoaderContent>
        </StyledEmptyPageLoaderContainer>
    );
};

export default EmptyPageLoader;
